<!--
 * @Descripttion: 投放广告（意愿）
 * @version: 
 * @Author: chenzc
 * @Date: 2023-2-8 16:05:14
 * @LastEditors: 
 * @LastEditTime: 
-->
<template>
    <div v-if="!isSubmitSuc" class="adsense_contianer">
        <div class="input_container">
            <div>
                <div class="input_item">
                    <div class="left">
                        <span>*</span>
                        客户姓名：
                    </div>
                    <input class="input_box" placeholder="请输入您的真实姓名" v-model="username">
                </div>
                <div class="input_item">
                    <div class="left">
                        <span>*</span>
                        联系电话：
                    </div>
                    <input 
                        class="input_box" name="mobile" id="mobile" required  type="number" maxlength="11" placeholder="请输入你的联系电话" 
                        oninput="if(value.length>11) value=value.slice(0,11)" v-model.trim="userPhone">
                </div>
                <div class="input_item textarea_item">
                    <div class="left">
                        <span>*</span>
                        广告需求：
                    </div>
                    <textarea class="textarea" placeholder="请描述您的广告需求" v-model="userDesired"></textarea>
                </div>
            </div>
            <van-button class="submit_btn" size="large" @click="submitMes">提交</van-button>
        </div>
    </div>
    <div v-else class="suc_container">
        <img class="suc_img" src="../../assets/img/suc.png" alt />
        <div class="suc_title">提交成功</div>
        <div class="suc_remind">您的广告需求已提交成功，我们将在一个工作日内与您联系</div>
    </div>
    
</template>
  
<script>
import { submitAdSenseApi, submitAdSenseExpert } from "@/api/buyer/index";
// import { METHODS } from "http";
export default {
    data() {
        return {
            isSubmitSuc: false, //提交是否成功
            username:'', // 客户姓名
            userPhone: '', // 联系电话
            userDesired: '', // 广告意愿
        }
    },
    methods: {
        returnBack() {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                //微信环境
                wx.miniProgram.getEnv(function(res) {
                if (res.miniprogram) {
                    //小程序环境下逻辑
                    wx.miniProgram.navigateBack({ delta: 1 });
                } else {
                    //非小程序环境下逻辑
                }
                });
            } else {
                //非微信环境逻辑
                let u = navigator.userAgent,
                app = navigator.appVersion;
                let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                let isOS = isAndroid ? true : false;
                if (isOS) {
                    // Android环境
                    window.Android.closeHandsel();
                } else {
                // ios环境
                    window.webkit.messageHandlers.closeHandsel.postMessage("");
                }
            }
        },
        async submitMes() {
            if(!this.username) {
                this.$toast('请输入姓名');
                return
            }
            if(!this.userPhone) {
                this.$toast('请输入手机号');
                return
            }else {
                // 验证手机号
                const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if(!myreg.test(this.userPhone)) {
                    this.$toast('请输入正确电话号码')
                    return
                } 
            }
            if(!this.userDesired) {
                this.$toast('请描述您的广告需求');
            }
            const reqObj = { 
                name: this.username,
                phone: this.userPhone,
                remark: this.userDesired
            };
            let res;
            if(this.GetQueryString("source") == 1){
                res = await submitAdSenseApi(reqObj)
            }else{
                res = await submitAdSenseExpert(reqObj)
            }
            if (res.appStatus.errorCode == 0) {
                document.title= '提交成功'
                this.isSubmitSuc = true
                this.$toast('提交成功');
                setTimeout(() => {
                    this.returnBack();
                }, 1500);
            }else {
                this.$toast('提交失败');
            }
            
        }
    }
    

}
</script>

<style lang="scss" scoped>
    .adsense_contianer {
        width: 100%;
        height: 100%;
        background-image: url('~@/assets/img/ad_bg.png');
        background-size: 100vw 100vh;
    }
    .input_container {
        padding: 320px 32px 0 32px;
        .input_item {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 15px;
            .left {
                width: 200px;
                font-size: 16px;
                color: #fff;
                font-weight: bold;
                span {
                    color: red;
                }
            }
            .input_box {
                width: 434px;
                height:40px;
                padding: 0 10px;
                box-sizing: border-box;
                font-size: 14px;
                border-radius: 6px;
            }
        }
        .textarea_item {
            flex-direction: column;
            .left {
                text-align: left;
                align-self: flex-start;
            }
            .textarea {
                width: 100%;
                min-height: 100px;
                padding: 5px 10px;
                box-sizing: border-box;
                font-size: 14px;
                border-radius: 6px;
                margin-top: 10px;
                resize: none;
            }
        }
    }
    .submit_btn {
        margin-top: 27px;
        border-radius: 5px;
        background-color: rgb(129,211,248);
        font-size: 18px;
        font-weight: bold;
        color: #fff;
    }
    .suc_container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .suc_img {
            width: 30px;
            height: 30px;
            margin-top: 40px;
        }
        .suc_title {
            font-size: 15px;
            font-weight: bold;
            margin-top: 10px;
        }
        .suc_remind {
            font-size: 13px;
            color: #999999;
            margin-top: 30px;
        }
    }
</style>


